import useEvent from '@lyearn/core/hooks/useEvent';
import { CheckmarkOutline } from '@lyearn/icons';
import { BaseMenuItem, Typography } from '@lyearn/ui';

import { BaseSortMenuItem, SortMenuItemProps } from '../SortMenuItems/types';

const SortMenuItemMobile = <T extends BaseSortMenuItem>(props: SortMenuItemProps<T>) => {
  const { item, isSelected, onAction } = props;
  const { label, Icon } = item;

  const onClick = useEvent(() => {
    onAction(item);
  });

  return (
    <BaseMenuItem
      className="relative flex items-center rounded-8 py-14 px-16 hover:bg-bg-tertiary"
      onClick={onClick}>
      {Icon ? (
        <Icon className="h-24 w-24 flex-shrink-0 me-12" fillColorToken="icon-active" />
      ) : null}
      <Typography className="flex-1 me-16" color="text-text-primary" variant="body-short-01">
        {label}
      </Typography>
      {isSelected ? (
        <CheckmarkOutline
          className="absolute h-24 w-24 flex-shrink-0 end-12"
          fillColorToken="icon-active"
        />
      ) : null}
    </BaseMenuItem>
  );
};

export default SortMenuItemMobile;
